module.exports = __webpack_public_path__ + "img/tabar_home1.f0428514.png";